
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/c/blog-posts/curipod-upskills-new-teachers-and-reduces-planning-time-by-30",
      function () {
        return require("private-next-pages/c/blog-posts/curipod-upskills-new-teachers-and-reduces-planning-time-by-30.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/c/blog-posts/curipod-upskills-new-teachers-and-reduces-planning-time-by-30"])
      });
    }
  